export default __webpack_public_path__ + "static/media/xero.551a7d9c.svg";